
<template>
<section>
  <div class="tabbed-content">
    <div class="columns">
      <div class="col">
        <chc-input v-model="data.company_name" label="Company Name" :required="true" :error="errors.company_name"></chc-input>
        <chc-input v-model="data.address_street" label="Mailing Address" :required="true" :error="errors.address_street"></chc-input>
        <chc-input v-model="data.address_city" label="City" :required="true" :error="errors.address_city"></chc-input>
        <chc-input v-model="data.address_state" label="State" format="combo"
                   :autoCompleteValues="$store.state.constants.us_states_list" :required="true" :error="errors.address_city"></chc-input>
        <chc-input v-model="data.address_zip" label="Zip" format="zip" :required="true" :error="errors.address_zip"></chc-input>
        <chc-input v-model="data.email" label="Email Address" :required="true" :error="errors.email"></chc-input>
        <chc-input v-model="data.phone" label="Phone" :required="true" :error="errors.phone"></chc-input>
        <h3>Fees</h3>
        <chc-input v-model="data.default_auction_fee_cents" label="Default Auction Fee" format="currency"></chc-input>
        <chc-input v-model="data.default_conditioning_fee_cents" label="Default Miscellaneous Fee" format="currency"></chc-input>
      </div>
      <div class="col">
        <chc-input v-model="data.preferred_towing_company_id" label="Preferred Towing Company"
                   :autoCompleteValues="$store.state.towingCompanies.towingCompaniesList" format="combo"></chc-input>
        <h3>Default Towing Destination <!-- <a href="#" @click="copyTowingAddress">Copy Company Address</a> --></h3>
        <chc-input v-model="data.towing_address_street" label="Address"></chc-input>
        <chc-input v-model="data.towing_address_city" label="City"></chc-input>
        <chc-input v-model="data.towing_address_state" label="State" format="combo"
                   :autoCompleteValues="$store.state.constants.us_states_list"></chc-input>
        <chc-input v-model="data.towing_address_zip" label="Zip" format="zip"></chc-input>
      </div>
    </div>
    <div class="columns">
      <div class="col">
        <div class="field left">
          <span v-if="hasErrors" class="error-message">
            There were errors processing the form. Please fix the fields above.
          </span>
          <div class="submit-section">
            <input type="submit" class="btn" value="Save Changes" @click="saveChanges">
          </div>
          <transition name="fade">
            <p v-if="saved" class="success-message">Proceeds Data Saved</p>
          </transition>
        </div>
      </div>
    </div>

  </div>
</section>
</template>

<script>
import store from '@/store'

export default {
  name: 'BuyerInformation',
  data () {
    return {
      errors: [],
      hasErrors: false,
      saved: false,
    }
  },
  props: ['data', 'buyerId'],
  methods: {
    copyTowingAddress () {
    },
    saveChanges () {
      store.functions.buyers.updateBuyer(this.buyerId, this.data, (errors) => {
        this.saved = false
        this.errors = errors
        this.hasErrors = true
      }).then(() => {
        // this.$router.push({name: 'BuyersSummary'})
        this.hasErrors = false
        this.errors = {}
        this.saved = true
        this.$emit('refresh')
        setTimeout(() => {
          this.saved = false
        }, 500)
      })
    }
  },
  computed: {
  }
}
</script>

<style>
.fade-enter-active, .fade-leave-active {
    opacity: 1;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
    transition: opacity 3s;
    opacity: 0;
}

</style>



// WEBPACK FOOTER //
// src/components/Buyer/BuyerInformation.vue